import type * as Sentry from '@sentry/nextjs'

type SentryTransport = NonNullable<
  Parameters<typeof Sentry.init>[0]['transport']
>
type SentryTransportOptions = Parameters<SentryTransport>[0]

const noopTransportResponse = {
  statusCode: 200,
  headers: {
    'retry-after': null,
    'x-sentry-rate-limits': null,
  },
}

export const makeSentryNoopTransport: SentryTransport = (
  _options: SentryTransportOptions,
) => {
  return {
    send: () => Promise.resolve(noopTransportResponse),
    flush: () => Promise.resolve(true),
  }
}
